import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy, Input, Injector, OnChanges, SimpleChanges } from '@angular/core';
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { HttpClient } from '@angular/common/http';
import { EntityItemModule } from '../entity.item';
import { PickerBaseComponent, PickerFetch } from '@jms/ui/ui.pickers.base';
import { Entity } from '@jms/model';

@Component({
  selector: 'stage-picker',
  templateUrl: './stage.picker.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgSelectModule,
    EntityItemModule
  ],
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: StagePickerComponent, multi: true }
  ]
})
export class StagePickerComponent extends PickerBaseComponent implements OnInit, OnChanges {

  @Input() public data: Entity[];
  @Input() public placeholder = '<Stage>';
  @Input() public jobId: string;

  public data$: Observable<Entity[]>;

  constructor(
    injector: Injector,
    private http: HttpClient
  ) {
    super(injector);
  }

  public ngOnChanges(changes: SimpleChanges) {

    this.data$ = this.fetch === PickerFetch.Automatic
      ? this.getStages()
      : of(this.data);

  }

  private getStages(): Observable<Entity[]> {
    return this.http.get<Entity[]>(`/api/workorders/picker/${this.jobId}`);
  }


}
